import ErrorBoundary from './Errorboundary';

export default ErrorBoundary;
